import type { UIState } from './types';

const getSelectedViewMode = (state: UIState) => state.selectedViewMode;
const isUserDateSelectionAllowed = (state: UIState) =>
  state.allowUserDateSelection;
const isNoDirectsMessageDismissed = (state: UIState) =>
  state.noDirectsMessageDismissed;

export default {
  getSelectedViewMode,
  isUserDateSelectionAllowed,
  isNoDirectsMessageDismissed,
};
